import React from 'react'
import clsx from 'clsx'
import Link from '../../../Link'
import StyledIcon from '../../StyledIcon'
import { ctaAlignLeft, ctaAlignRight, linkInner } from './IconLink.module.scss'

const IconLink = ({
	color,
	size,
	name,
	href,
	cta,
	iconColor,
	align,
	round,
	state,
}) => {
	return (
		<Link to={href || ''} state={state} className="icon-link">
			<span className={linkInner}>
				<StyledIcon
					round={round}
					iconColor={iconColor}
					color={color}
					size={size}
					name={name || 'left'}
				/>
				{cta && (
					<span
						className={clsx(
							align && align === 'left' ? ctaAlignLeft : ctaAlignRight,
							'article-meta'
						)}
					>
						{cta || 'back to previous results'}
					</span>
				)}
			</span>
		</Link>
	)
}

export default IconLink
